export const DS_DATEPICKER_CLASSES = {
  Root: "ds-date-picker",
  StartOfWeekBase: "ds-date-picker--start-of-week-",
  Header: "ds-date-picker__header",
  MonthYearSelector: "ds-date-picker__month-year-selector",
  PeriodSelector: "ds-date-picker__period-selector",
  PeriodSelectorMonth: "ds-date-picker__period-selector--month",
  PeriodSelectorYear: "ds-date-picker__period-selector--year",
  PeriodOption: "ds-date-picker__period-option",
  PeriodOptionSelected: "ds-date-picker__period-option--selected",
} as const;

export const DS_DATEPICKER_PERIOD_SELECTOR_CLASSES_MAP: Record<"month" | "year", string> = {
  month: DS_DATEPICKER_CLASSES.PeriodSelectorMonth,
  year: DS_DATEPICKER_CLASSES.PeriodSelectorYear,
};
